<template>

    <div class="arrow" :class="classes"></div>

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .arrow {
        height: 0;
        width: 0;
        &.arrow-left {
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-right: 5px solid $color-text;
        }
        &.arrow-right {
            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 5px solid $color-text;
        }
        &.arrow-up {
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid $color-text;
        }
        &.arrow-down {
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid $color-text;
        }
    }

</style>

<script>

export default {

    props: {
        dir: {
            type: String,
            default: 'd',
        },
    },

    computed: {

        classes() {
            return {
                'arrow-left': this.dir === 'l',
                'arrow-right': this.dir === 'r',
                'arrow-up': this.dir === 'u',
                'arrow-down': this.dir === 'd',
            }
        }

    },

}

</script>
